<template>
  <div class="grid myhome-events">
    <SidebarEvents v-if="['events', 'events-package'].indexOf($route.name) > -1 && registrationsLoaded">
      <div class="dea-list-catalog__main-list dea-list-catalog__main-list--back-to-formazione">
        <div class="dea-list-catalog__main-list-item">
          <Links href="https://formazione.deascuola.it/" target="_blank">
            <span class="icon dea-links__icon dea-ico-go-to"></span>
            <span class="text dea-links__text">Torna all'offerta formativa</span>
          </Links>
        </div>
      </div>
      <SidebarLinkList :items="myHomeLinks"></SidebarLinkList>
    </SidebarEvents>
    <Sidebar v-else-if="['registration'].indexOf($route.name) > -1 && registrationIsLoaded">
      <Registrations :registrations="[activeRegistration()]"></Registrations>
    </Sidebar>
    <Sidebar v-else-if="['registration'].indexOf($route.name) === -1 && registrationsLoaded">
      <Registrations :registrations="[activeRegistration()]"></Registrations>
    </Sidebar>
    <router-view v-if="registrationsLoaded"></router-view>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import SidebarLinkList from "@/components/elements/SidebarLinkList";
import Links from "@/components/elements/Links";
import Loader from "@/components/elements/Loader";
import SidebarEvents from "~/components/events/components/SidebarEvents";
import Sidebar from "~/components/events/components/Sidebar";
import Registrations from "~/components/events/components/Registrations";

export default {
  name: "EventsMain",
  components: {
    Links,
    SidebarEvents,
    Registrations,
    Sidebar,
    SidebarLinkList,
    Loader,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$route.params.ticketFilter) {
        vm.setTicketFilter(vm.$route.params.ticketFilter);
      } else {
        const mainTab = vm.myHomeLinks[0];
        for (let i = 0; i < vm.myHomeLinks.length; i += 1) {
          const el = vm.myHomeLinks[i];
          vm.setTicketFilter(el.status);
          if (vm.filteredRegistrations().length) return;
          if (i === vm.myHomeLinks.length - 1) vm.setTicketFilter(mainTab.status);
        }
      }
    });
  },
  computed: {
    ...mapGetters([
      "user",
      "config",
      "ticketFilter",
      "titles",
      "activeRegistration",
      "registrationsLoaded",
      "registrationIsLoaded",
      "filteredRegistrations",
    ]),
    myHomeLinks() {
      return [
        {
          name: this.titles.sidebar.future,
          active: this.ticketFilter === "future",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "future",
        },
        // {
        //   name: this.titles.sidebar.festival,
        //   active: this.ticketFilter === "festival",
        //   colorMod: "dea-border-target-magenta-formazione",
        //   action: this.changeView,
        //   status: "festival",
        // },
        {
          name: this.titles.sidebar.past,
          active: this.ticketFilter === "past",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "past",
        },
        {
          name: this.titles.sidebar.waitingList,
          active: this.ticketFilter === "waitingList",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "waitingList",
        },
        {
          name: this.titles.sidebar.ordersRecap,
          active: this.ticketFilter === "ordersRecap",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "ordersRecap",
        },
      ];
    },
  },
  created() {
    if (
      !this.registrationsLoaded &&
      this.user &&
      this.user.datiLogin &&
      !this.user.datiLogin.seiUn === "studente" &&
      !this.user.datiLogin.seiUn === "genitore"
    ) {
      this.fetchRegistrations({ registrationId: this.$route.params.registration });
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.page && this.$route.query.page === "past") {
      this.setTicketFilter("past");
    }
  },
  methods: {
    ...mapMutations(["setTicketFilter", "setViewChanged", "setPage"]),
    ...mapActions(["fetchRegistrations"]),
    async changeView(status) {
      this.setTicketFilter(status.status);
      this.setViewChanged(true);
      this.setPage(1);
      if (this.$route.name !== "events") {
        this.$router.push({ name: "events" });
      }

      await this.fetchRegistrations();
    },
  },
};
</script>

<style lang="scss">
.dea-list-catalog__main-list.dea-list-catalog__main-list--back-to-formazione {
  border-bottom: 0;
  margin-bottom: $space-small;

  .dea-list-catalog__main-list-item {
    .dea-links__icon {
      rotate: 180deg;
    }

    .dea-links {
      .dea-links__label {
        align-items: center;
        border-bottom: 0;
        column-gap: $space-x-small;
        display: flex;

        .dea-links__text {
          border-bottom: 2px solid $dea-color-target-magenta-formazione;
          font-family: $font-primary;
        }
      }
    }
  }
}
</style>
